export default "__VITE_ASSET__BKtnTjaG__"